import modal from 'assets/components/modal/modal';

import './funnelHeader.scss';

const setProgress = (progress = 20) => {
  const el = document.querySelector('.js-funnelProgress');
  if (!el) {
    return;
  }

  el.setAttribute('data-progress', progress);
};

const onHowManyClick = function onFunnelHowManyClick(ev) {
  ev.preventDefault();
  modal.open('modal-how-many');
};

const init = function initFunnelHeader() {
  modal.init();

  [].forEach.call(
    document.querySelectorAll('.js-howMany'),
    (el) => {
      el.addEventListener('click', onHowManyClick);
    },
  );
};

const destroy = function destroyFunnelHeader() {
  modal.destroy();

  [].forEach.call(
    document.querySelectorAll('.js-howMany'),
    (el) => {
      el.removeEventListener('click', onHowManyClick);
    },
  );
};

export default {
  destroy,
  init,
  setProgress,
};
